define((require) => {
    "use strict";

    const Backbone             = require("backbone");
    const ExperienceModel            = require("shared/ui/experience/ExperienceModel");
    const RestApi = require("shared/services/RestApi");
    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const SyncManager = require("shared/services/sync/SyncManager");

    const DEFAULT_DESCRIPTION  = "(New Template)";

    /**
     * The experience template model.
     *
     */
    const TemplateModel = ImprovedModel.extend("TemplateModel", {

        defaults: {
            id: null,                               // ObjectId
            name: null,                             // String
            description: DEFAULT_DESCRIPTION,
            content: null,                          // JSON of ExperienceModel
            companyId: null,                        // ObjectId
            createdAt: null,                        // Number(int)
            createdBy: null,                        // ObjectId
            globallyAccessible: null,               // Boolean
            version: null                           // Number(int)
        },

        relations: [{
            type: Backbone.One,
            key: "content",
            relatedModel: ExperienceModel
        }],

        url() {
            return this.isNew()
                ? RestApi.pathToCollection(RestApi.Collections.TEMPLATES)
                : RestApi.pathToSpecificResource(RestApi.Collections.TEMPLATES, this.id);
        }

    }, {

        DEFAULT_DESCRIPTION,

        fromExperience(experienceId) {
            const path = RestApi.pathToSpecificResource(RestApi.Collections.TEMPLATES_PUBLISHABLE, experienceId);

            return SyncManager
                .getJSON(path, SyncManager.target("TemplateModel.fromExperience"))
                .then((json) => new TemplateModel(json));
        }

    });

    return TemplateModel;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/TemplateModel.js